var reloadsPerformed = 0;
var wall;
var previousMenuItems;
var isDragging = false;
var lastMenuClick;
var prevX;
var prevY;
var PERSONAL_ELEMENTS_HOME;
var PREVIOUS_PERSONAL_ELEMENTS_HOME;

HomePageSortcutElement = function (fatexec, ex, ename, etype, title, type, countissues, help, enabled, checked, icontype, shortcuts, url) {
	this.fatexec = fatexec;
	this.ex = ex;
	this.ename = ename;
	this.etype = etype;
	this.title = title;
	this.type = type;
	this.countissues = countissues;
	this.help = help;
	this.enabled = enabled;
	this.checked = checked;
	this.icontype = icontype;
	this.shortcuts = shortcuts;
	this.url = url;
};

var homepageWidget = "homepage-widget";

var widgets = [
	{ename: "WWWDBTODOLIST", compName: "TDL"}
];

var activeWidgets = new Set();

function renderHomepageWidgets() {
	const isNewHomepage = window?.common?.getIsNewHomepage?.();
	if(isNewHomepage) return;
	activeWidgets?.forEach(w => window.renderComponent(w.compName, w.ename, w.props));
}

function unmountHomepageWidgets() {
	activeWidgets?.forEach(w => window.umnountReactComponent(w.ename));
}

function removeWidget (ename, elementToRemove) {
	activeWidgets.forEach(w => {
		if (w.ename == ename) {
			activeWidgets?.delete(w);
			window.umnountReactComponent(ename);	
		}
	});
	removeItem(elementToRemove);
}

function isRtl() {
	if (getLang() == 1 || getLang == 28)
		return true;
	return false;
}

function create_home_element_array_from_xml(ex,xmlDoc)
{
    var elementArray = new Array();
    $(xmlDoc).find('Menu').each(function () {
        var issues = $(this).find('countIssues').first().text();
        if (issues.length > 3)
            issues = '999+';
		var elem = new HomePageSortcutElement(ex,
			$(this).find('exec').first().text(),
			$(this).find('ename').first().text(),
			$(this).find('etype').first().text(),
			$(this).find('title').first().text(),
			$(this).find('type').first().text(),
			issues,
			$(this).find('help').first().text(),
			$(this).find('enabled').first().text(),
			$(this).find('checked').first().text(),
			 $(this).find('icontype').first().text(),
			$(this).find('shortcut').first().text(),
			$(this).find('url').first().text());
		elementArray.push(elem);
	});
	return elementArray;
}

function getChild(frame)
{
	return document.getElementById(frame);
}

function reloadThePortlet(frame)
{
	frame.contentWindow.location.reload();
}

function getChildElement(frame, elementid)
{
	if (frame == null)
		return null;
	if (frame.contentDocument != null) {
		return frame.contentDocument.getElementById(elementid);
	}
	
	return null;
}

function reloadPortlet(frameName)
{
	var frame = getChild(frameName)
	if (frame == null)
		return;
	if (getChildElement(frame,"NAM") != null) 
	{
		setTimeout(reloadThePortlet, 1000 + (reloadsPerformed * 2500), frame);
		++reloadsPerformed
	}
}

function activateDateDialog(frameName)
{
	var frame = getChild(frameName);
	if (frame == null)
		return
	if (frame.contentWindow.activatePriformDates == null)
		return;
	frame.contentWindow.activatePriformDates();
}

function moveUpInDomTreeToFindChildIFrame(theControl)
{
	if ($(theControl).find("IFrame").length > 0)
		return theControl.find("IFrame");
	if ($(theControl).parent().length > 0)
		return moveUpInDomTreeToFindChildIFrame($(theControl).parent());
	return null;
}

function portletDropdownMenu(menuToExpand, elementToClickOn) {
	lastMenuClick = new Date();
	$theParent = ($(menuToExpand).parent());
	if ($theParent == null || $theParent.length == 0){
		console.log('Error - null parent in portletDropdownMenu');
		return;
	}
	$menuTop = $theParent.find("ul");
	if ($menuTop == null || $menuTop.length == 0){
		console.log('Error - null menuTop in portletDropdownMenu');
		return;
	}
	try{
		if (moveUpInDomTreeToFindChildIFrame($theParent).contents().find("#DateRange").length == 0)
		{
			$menuItemToRemove = $menuTop.find("#portlet_menue_item_1");
			if ($menuItemToRemove != null && $menuItemToRemove.length > 0){
				$menuItemToRemove.remove();
			}		
		}
	}catch(err){
		console.log("Error when checking date range in iframe");
	}
	document.getElementById(elementToClickOn).classList.toggle("portletShow");
	$(".portletBigDots").addClass("active");
}

function openMenu(elementToClickOn)
{
	if (document.getElementById(elementToClickOn) != null){
		lastMenuClick = new Date();
		document.getElementById(elementToClickOn).parentElement.classList.toggle("portletShow");
		$(".portletBigDots").addClass("active"); 
	}
}

function allowMenuActivate()
{
	personalMenuActive = true;
}

function menuItemToName(item) {
	if ($(item).find("div#" + homepageWidget)?.length > 0) {
		var res = $(item).find("div#" + homepageWidget).attr("name");
		return res;	
	}
	
	if ($(item).find("a").attr("id") == null || $(item).find("a").attr("id").indexOf('portlet_menue_item') >= 0)
		return null;
	if ($(item).find("a").attr("id").indexOf('portletDropdownMenuID') < 0)
		return $(item).find("a p").text();
	return $(item).find("table").attr("name");
}

function menuItemToID(item) {
	if ($(item).find("div#" + homepageWidget)?.length > 0) {
		var element = $(item).find("div#" + homepageWidget).children()[0];
		var res = $(element).attr("id");
		return res;	
	}

	if ($(item).find("a").attr("id") == null || $(item).find("a").attr("id").indexOf('portlet_menue_item') >= 0)
		return null;
	if ($(item).find("a").attr("id").indexOf('portletDropdownMenuID') < 0)
		return $(item).find("a").attr("id").replace("merk_menu_item_", "");
	return $(item).find("table").attr("id");
}

function haveElementsChanged()
{
	if (PREVIOUS_PERSONAL_ELEMENTS_HOME != null)
	{
		if (PERSONAL_ELEMENTS_HOME.length != PREVIOUS_PERSONAL_ELEMENTS_HOME.length)
			return true;
		for (i = 0; i < PERSONAL_ELEMENTS_HOME.length; i++) 
		{
			if (PERSONAL_ELEMENTS_HOME[i].url != PREVIOUS_PERSONAL_ELEMENTS_HOME[i].url){
				return true;
			}
		}
		return false;
	}
}

function hasMenuChanged(PERSONAL_ELEMENTS_HOME)
{
	// We dont repaint the screen just because the icons have changed order.  We are checking to see if the number of issues have changed though - this will
	// cause a repaint since the screen will no longer be accurate without a repaint.
	var theResult = false;
	var currentMenuItemIndex = 0;
	 jQuery.each($('.subjectsMenuItem'), function (index, item) {
			var title = menuItemToName(item);
			if (title != null){
				if ($(item).find("div#" + homepageWidget)?.length > 0) {
					countIssues = "0"; 
				} else {
					countIssues = $(item).find("span")[0].textContent;
					if ($(item).find("span")[0].className == "portletBigDots")
					countIssues = "0";
					
				}
				if (PERSONAL_ELEMENTS_HOME[currentMenuItemIndex].title == title && countIssues != PERSONAL_ELEMENTS_HOME[currentMenuItemIndex].countissues)
				{
					theResult = true;
				}
				++currentMenuItemIndex;
			}
	 });
	if ($('.subjectsMenuItem').length != PERSONAL_ELEMENTS_HOME.length)
		return true;
	return theResult;
}

function getPosition(item, parentWidth)
{
	var top = $(item).get(0).offsetTop;
	var left = $(item).get(0).offsetLeft;
	var position = (top * parentWidth) + left;
	if (isRtl())
	{
		position = (top * parentWidth) + (parentWidth - left);
	}
	return position;
}

// GT - This is necessary because freewall doesnt store items in order - it just places items using x and y coordinates.
// We therefore sort based on an order we create from the x y coordinates.

function hasViewChanged()
{
	var theResult = false;
	currentMenuItems = $('.subjectsMenuItem');
	if (previousMenuItems == null || currentMenuItems.length != previousMenuItems.length)
		return true;
	
	var currentMenuItemIndex = 0;
	 jQuery.each(currentMenuItems, function (index, item) {
			var title = menuItemToName(item);
			if (title != null){
				var previousMenuItemTitle = menuItemToName(previousMenuItems[currentMenuItemIndex]);
				if (previousMenuItemTitle == null || previousMenuItemTitle != title)
					theResult = true;
				++currentMenuItemIndex;
			}
	 });
	 return theResult;
}

function areThereGapsInGrid()
{
	iconsWidthPosition = $('.subjectsMenuItem[data-position]');
	
	if (iconsWidthPosition == null || iconsWidthPosition.length < 1)
		return false;
	if (iconsWidthPosition.length == 1 && currentMenuItems.last().attr("id") != iconsWidthPosition.last().attr("id"))
		return false;
	return true;
}

function persistScreenElementsToServer(ul)
{
	var xml = "<?xml version='1.0' encoding='UTF-8'?><NewDataSet>";
	currentMenuItems = $('.subjectsMenuItem');
	if (previousMenuItems != null && Math.abs(currentMenuItems.length - previousMenuItems.length) > 1)
	{
		console.log("persistScreenElementsToServer: will not persist menu items - change is too large indicating something may be wrong currentMenuItems=" + currentMenuItems.length + " previousMenuItems=" + previousMenuItems.length);
		return;
	}
	jQuery.each(currentMenuItems, function (index, item) {
		try{
			var title = menuItemToName(item);
			var id = menuItemToID(item);
			if (id != null && title != null)
			{
				var exec = id.split('_')[0];
				xml += "<Menu><exec>" + exec + "</exec><title>" + title + "</title></Menu>"
			}
		} catch (err){
			console.err("persistScreenElementsToServer: caught exception while attempting to save screen elements to server.  " + err);
		}
	 });

	 xml += "</NewDataSet>";
	 HomePageSet(xml);
}

function getPortletMenuHtmlText(ex, title, ename, url) {
	var isRtlText = isRtl();
	var rtlClass = isRtlText ? "rtlText" : "";
	var htmlElements = "<table id='" +ex+ "' name='" +title+ "'>";
	htmlElements += "<tr><td width='24' align='right'>";
	htmlElements += "<div id='portletPulldownMenu' class='topPortletDropdown'>";
	htmlElements += "<a href='#' id='portletDropdownMenuID' title=\"" + window.getMenuOptionsTitle() + "\" onclick='portletDropdownMenu(this, \"portletDropdownMenuHook" + ex + "\")'>";
	htmlElements += "<span class='portletBigDots' /></a>";
	htmlElements += "<ul class='portletDropdownContentWide "+rtlClass+"' id='portletDropdownMenuHook" + ex + "'>";
	htmlElements += "<li class='portletItem' ";
	htmlElements += "id='portlet_menue_item_3' onclick='removeItem(\"closeMenuHook" + ex + "\")'><span class='portletItemText'>" +  window.getRemovePortletTitle() +"</span></li>";
	htmlElements += "<li class='portletItem' ";
	htmlElements += "id='portlet_menue_item_1' onclick='activateDateDialog(\"" + ename + "\");'><span class='portletItemText'>" +  window.getChangeDateRangeTitle() +"</span></li>";
	htmlElements += "<li class='portletItem'  onclick='window.open(\"" + url + "\")' data-type='Menu' data-enabled='1' id='portlet_menue_item_2' title=''><span class='portletItemText'>" + window.getOpenInNewWindowTitle() +"</span></li></ul></td>";
	htmlElements += "<td class='portletTitle' height='40px' align='center'>" + title + "</td></tr>";
	htmlElements += "<tr><td colspan='2'>";
	htmlElements += "<iframe id='" + ename + "' src='" + url + "' width='535px' height='224px' frameborder='0' scrolling='no' allowtransparency='true' onload='reloadPortlet(\"" + ename + "\");'>";
	htmlElements += "</td></tr></table></div>";
	return htmlElements;
}

function getWidgetMenuHtmlText(ex, title, ename) {
	var htmlElements = "<div id='" + homepageWidget + "' name='" +title+ "'>";
	htmlElements += "<div id='" + ex + "'>";
	htmlElements += "<div id='" + ename + "'>";
	htmlElements += "</div></div></div></div>";
	return htmlElements;
}

function getIconMenuHtmlText(ex) {
	var isRtlText = isRtl();
	var rtlClass = isRtlText ? "rtlText" : "";
	var htmlElements =	"<div id='portletPulldownMenu' class='topIconPortletDropdown' onclick='openMenu(\"pulldownMenuHook" + ex + "\")'><span class='portletBigDots' />";	
	htmlElements += "<div class='portletDropdownContainer'>";
	htmlElements += "<div id='pulldownMenuHook" + ex + "' class='portletDropdownContent "+rtlClass+"' onclick='removeItem(\"closeMenuHook" + ex + "\")'>" + window.getRemovePortletTitle();
	htmlElements += "</div></div></div>";
	return htmlElements;
}

function showMenu(theIcon)
{
	if (window.isMobile())
		return;
	$(theIcon).find(".topIconPortletDropdown").show();
	$(theIcon).find(".topPortletDropdown").show();
	$(theIcon).find(".topIconPortletDropdownLtr").show();
}

function hideMenu(theIcon)
{
	if (window.isMobile())
		return;
	$(theIcon).find(".topIconPortletDropdown").hide();
	$(theIcon).find(".topPortletDropdown").hide();
	$(theIcon).find(".topIconPortletDropdownLtr").hide();
	$(theIcon).find(".portletShow").removeClass("portletShow");
	$(".portletBigDots").removeClass("active"); 
}

function hideAllIconMenus()
{
	if (window.isMobile())
		return;
	$(".topIconPortletDropdown").hide();
	$(".topIconPortletDropdownLtr").hide();
	$(".topPortletDropdown").hide();
}

function getMenuItemHtmlHook(staticParams, id)
{
	return " onclick=\"personal_item_menue_click(" + id + staticParams  + "\"";
}

function iconTypeToIconName(icontype) {
		if (icontype == 'F') {
			return 'screen_icon.svg';
		}
		if (icontype == 'R') {
			return 'report_icon.svg';
		}
		if (icontype == 'W') {
			return 'wizard_icon.svg';
		}
		if (icontype == 'P') {
			return 'process_icon.svg';
		}
		if (icontype == 'B') {
			return 'dashboard_icon.svg';
		}
		if (icontype == 'O') {
			return 'bi_icon.svg';
		}
		return 'invoice_icon.svg';
}

function iconTypeToBackgroundClass(icontype) {
		if (icontype == 'F') {
			return 'screen-icon';
		}
		if (icontype == 'R') {
			return 'report-icon';
		}
		if (icontype == 'W') {
			return 'wizard-icon';
		}
		if (icontype == 'P') {
			return 'process-icon';
		}
		if (icontype == 'B') {
			return 'dashboard-icon';
		}
		if (icontype == 'O') {
			return 'bi-icon';
		}
		return 'invoice-icon';
}

function getDigitsClass(issuesCount) {
	var numOfDigits = "";
	if (issuesCount > 999) {
		numOfDigits += "fourDigits";
	} else if (issuesCount > 99) {
		numOfDigits += "threeDigits";
	} else if (issuesCount > 9) {
		numOfDigits +=  "twoDigits";
	} 
	return numOfDigits;
}

function getTileTitleClass(title) {
	var isOneWord = title.trim().indexOf(' ') == -1;
	return isOneWord ? "singleWordTitle" : null;
}

function createStaticParams(PERSONAL_ELEMENTS_HOME)
{
	return "," + PERSONAL_ELEMENTS_HOME.fatexec + "," + PERSONAL_ELEMENTS_HOME.ex + ",'" + PERSONAL_ELEMENTS_HOME.etype + "','" + PERSONAL_ELEMENTS_HOME.ename + "','" + PERSONAL_ELEMENTS_HOME.type + "',event)";
}

function create_homepage_menu(ex, xmlData) {

	var homePage = $('.wrapper'); 
	if(homePage && homePage.hasClass('displayNone'))
		return;
		
	var feedExists = false;
	lastXmlData = xmlData;

	if ($(".subjectsMenu").length == 0)
		return;
	var $ul = $(".subjectsMenu");
	
	var $x = xmlData.replace('<?xml version="1.0" encoding="UTF-8"?>', '<?xml version="1.0" encoding="UTF-8"?><root>');
	$x += '</root>';

	xmlDoc = $.parseXML($x), $xml = $(xmlDoc);

	if (PERSONAL_ELEMENTS_HOME != null)
		PREVIOUS_PERSONAL_ELEMENTS_HOME = PERSONAL_ELEMENTS_HOME;
	PERSONAL_ELEMENTS_HOME = create_home_element_array_from_xml(ex,xmlDoc);
	// GT - This deals with a strange bug where if we delete all the icons from the main page, and then move some icons, sometimes the icons disappear.  
	if (previousMenuItems != null && PERSONAL_ELEMENTS_HOME.length == 0 && previousMenuItems.length > 1)
	{
		console.log("create_homepage_menu: WARNING - not refreshing homepage - Xml is empty but previous menu items are " + previousMenuItems.length + " we are not deleting all homepage icons");
		persistScreenElementsToServer($ul);
		return;
	}
	
	if (!rebuildhomepage && !haveElementsChanged() && !hasMenuChanged(PERSONAL_ELEMENTS_HOME)){
		console.log('Repaint not needed');		
		return;
	}
	rebuildhomepage = false;
	$ul.empty();

    if ($ul && $ul[0]) {
    	if (isRtl())
    	    $ul[0].parentElement.dir = "rtl";
    	else
			$ul[0].parentElement.dir = "ltr";
    }
    
    /* 	All active homepage widgets must be unmounted before reloading them in react
		Otherwise the widget's data is not rendered */
	unmountHomepageWidgets();
    
	for (i = 0; i < PERSONAL_ELEMENTS_HOME.length; i++) {
		if (PERSONAL_ELEMENTS_HOME[i].icontype != 'M') {
			var iconName = iconTypeToIconName(PERSONAL_ELEMENTS_HOME[i].icontype);
			var numberHtml = "";
			var backgroundClass = iconTypeToBackgroundClass(PERSONAL_ELEMENTS_HOME[i].icontype);
			var issuesCount = parseInt(PERSONAL_ELEMENTS_HOME[i].countissues);
			var staticParams = createStaticParams(PERSONAL_ELEMENTS_HOME[i]);
			
			if(issuesCount > 0) {
				var digitsClass = getDigitsClass(issuesCount);
				var issuesCountClass = issuesCount > 0 ? "label-number " +  digitsClass : "";
				numberHtml = "<div class='"+issuesCountClass+"'" + getMenuItemHtmlHook(staticParams, "7") + "><span>" + issuesCount + "</span></div>";
			}
			
			if (isRtl()) backgroundClass += ' img-to-left';
			var ex = PERSONAL_ELEMENTS_HOME[i].ex + '_' + i;
			var ename = PERSONAL_ELEMENTS_HOME[i].ename;
			var title = escapeUntrustedData(PERSONAL_ELEMENTS_HOME[i]?.title);
			var url = PERSONAL_ELEMENTS_HOME[i].url;
			var type = PERSONAL_ELEMENTS_HOME[i].type;
			var widget = widgets.find(w => w.ename == ename); 
			if (widget) {
				widget.props = {ex}
				activeWidgets.add(widget);
			}
			
			if (type != 'p' ) {
				var titleAttribute = "title=\""+title + "\"";
				var liText = '<div ' + titleAttribute + ' onmouseenter="showMenu(this)" onmouseleave="hideMenu(this)" data-width="140" data-height="140" class="subjectsMenuItem closeMenuHook' + ex + '\">';
				var $li = $(liText, {}).append(numberHtml);
				$li.data("personalElementsHome",PERSONAL_ELEMENTS_HOME[i]);
			}
			if (type == 'p' ) {
				var portletLiText = '<div onmouseenter="showMenu(this)" onmouseleave="hideMenu(this)" data-width="570" data-height="290" class="subjectsMenuItem portletMenuItem closeMenuHook' + ex + '\">';
				var widgetLiText = '<div data-width="590" data-height="290" class="subjectsMenuItem portletMenuItem homepageWidget closeMenuHook' + ex + '\">';
				var liText = widget ? widgetLiText : portletLiText;
				var $li = $(liText, {}).append(numberHtml);		
				var htmlElements = widget ? getWidgetMenuHtmlText(ex, title, ename) : getPortletMenuHtmlText(ex, title, ename, url);
				$li.append(htmlElements);
			}
			else if (PERSONAL_ELEMENTS_HOME[i].icontype != 'F' || window.isMobile())
			{
				var htmlElements = getIconMenuHtmlText(ex);
				$li.append(htmlElements);
				var $tile = $li.append($("<a href=\"#\" id=\"merk_menu_item_" + ex + "\"" + getMenuItemHtmlHook(staticParams, "1") + ">", {/*class: $cl*/ })
					.append("<div class='imgContainer "+backgroundClass+"'><img alt='' src='"+baseUrl+"/img/"+iconName+"' class='regular' ></img></div><p>"+title+"</p>"));//
			}
			else{
				var htmlElements = getIconMenuHtmlText(ex);
				$li.append(htmlElements);
				var tileTitleClass = getTileTitleClass(title);
				var paragraph = tileTitleClass ? "<p class='"+tileTitleClass+"'>"+title+"</p>" : "<p>"+title+"</p>";
				var $tile = $li.append($("<a href=\"#\" id=\"merk_menu_item_" + ex + "\"" + getMenuItemHtmlHook(staticParams, "1") + ">", {/*class: $cl*/ })
					.append("<div class='imgContainer "+backgroundClass+"'><img alt='' src='"+baseUrl+"/img/"+iconName+"' class='regular' ></img></div>" +
							paragraph, {}).append((!showfeed && ename == "FOLLOWUPLIST" && type == 'F' ? '<div class="feedbtn btnresize btnresizeclosed" title="Show Timeline" onclick="feedresize(event)"></div>' : '')
							+ "<div class='tile-footer'>" +
							"<img alt='' src='"+ baseUrl+"/img/search_24.svg' class='regular' " + getMenuItemHtmlHook(staticParams, "10") + "\" onmouseover=\"this.src='"+ baseUrl+"/img/search_24_hover.svg';\"onmouseout=\"this.src='"+ baseUrl+"/img/search_24.svg';\" />" +
							"<img alt='' src='"+ baseUrl+"/img/tile_plus_icon.svg' class='regular' " + getMenuItemHtmlHook(staticParams, "9") + "\" onmouseover=\"this.src='"+ baseUrl+"/img/tile_plus_hover.svg';\"onmouseout=\"this.src='"+ baseUrl+"/img/tile_plus_icon.svg';\"/>" +
							"</div>"));
			}
			$ul.append($li);	
        }
	}
	hideAllIconMenus();
	var el;
	if(el = document.getElementById("folowupfeed"))
		addfeed(el);
    resize_homepage();
	
	previousMenuItems = $('.subjectsMenuItem');

	organizeSubjectsMenuItem();
	if (navigator.userAgent.indexOf('Android') < 0 && navigator.userAgent.toUpperCase().indexOf('MAC') < 0)
    	{
           $(".subjectsContainer").mCustomScrollbar();
    	}
	
	// Safari Fix for Main Navigation Menu width
	var is_safari = navigator.userAgent.indexOf("Safari") > -1;
	var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;

	if (is_safari && !is_chrome) {
		$('nav.bottomHeader').css('padding', '0 60px');
	}
	renderHomepageWidgets();
}

function organizeSubjectsMenuItem()
{		
  var $ul = $(".subjectsMenu");
  wall = new Freewall('.subjectsMenu');
			wall.reset({
				draggable: true,
				selector: '.subjectsMenuItem',
				animate: true,
				cellW: 150,
				cellH: 150,
				rightToLeft: isRtl(),
				fixSize: 1,
				gutterX: 10,
				gutterY: 10, 			
				onResize: function() {
					wall.refresh();
				},
				onComplete: function() {
					currentDate = new Date();
					var diff = currentDate - lastMenuClick;
					var didViewChange = hasViewChanged()
					if (isDragging && didViewChange && (lastMenuClick == null || (currentDate - lastMenuClick > 1000)))
					{
						// We used to attempt to detect when we should force a refresh to avoid performance issues - but we picked performance issues over having the grid sometimes not look correct
						//if (areThereGapsInGrid())
							rebuildhomepage = true;
						persistScreenElementsToServer($ul);
					}
					isDragging = false;
				},
				onBlockDrop:function(event) {
					var diffX = prevX - event.screenX;
					var diffY = prevY - event.screenY;
					if (Math.abs(diffX) <= 10 && Math.abs(diffY) <= 10)
					{
						personalMenuActive = true;
					}
					if (event.target.className == 'portletBigDots' || (isDragging == true && Math.abs(diffX) <= 10 && Math.abs(diffY) <= 10))
					{
						isDragging = false;
						if (window.isMobile()){
							event.target.click();
						}
					}
				},
				onBlockDrag: function(event) {
					if (!window.isMobile())
						personalMenuActive = false;
					isDragging = true;
					prevX = event.screenX;
					prevY = event.screenY;
				}
			});
	wall.fitWidth();
	$(window).trigger("resize");
	// for some reason the spacing between icons is off causing some icons to be cut off.  We need a refresh to fix it.  Doing the refresh right away does not fix the problem - need to use the timeout to get this done.
	setTimeout(function() {
		wall.refresh()
	}, 4000);			

}
